import { Tracker } from 'src/lib/js/tracker'
import { TrackingEvents } from 'shared/components/common/tracking/TrackingEvents'
import {
  DeliveryInfo,
  DiningOptionBehavior,
  FulfillmentType
} from 'src/apollo/onlineOrdering'

export const trackEnteredDeliveryAddress = (
  tracker: Tracker,
  numItemsInCart: number,
  savedAddress: boolean,
  source: TrackingSource
) => {
  tracker.track(TrackingEvents.ENTERED_DELIVERY_ADDRESS, {
    num_items_in_cart: numItemsInCart,
    saved_address: savedAddress,
    source
  })
}

export const trackValidDeliveryAddressEntered = (
  tracker: Tracker,
  numItemsInCart: number,
  savedAddress: boolean,
  source: TrackingSource
) => {
  tracker.track(TrackingEvents.VALID_DELIVERY_ADDRESS_ENTERED, {
    num_items_in_cart: numItemsInCart,
    saved_address: savedAddress,
    source
  })
}

export const trackInvalidDeliveryAddressEntered = (
  tracker: Tracker,
  numItemsInCart: number,
  savedAddress: boolean,
  source: TrackingSource,
  deliveryValidationError: string = "You're out of range for delivery. To start an order, update your delivery address."
) => {
  tracker.track(TrackingEvents.DELIVERY_ADDRESS_VALIDATION_ERROR, {
    num_items_in_cart: numItemsInCart,
    saved_address: savedAddress,
    source,
    deliveryValidationError
  })
}

export const trackRedirectedToManualAddress = (
  tracker: Tracker,
  numItemsInCart: number,
  savedAddress: boolean,
  source: TrackingSource
) => {
  tracker.track(TrackingEvents.REDIRECTED_TO_MANUAL_ADDRESS, {
    num_items_in_cart: numItemsInCart,
    saved_address: savedAddress,
    source
  })
}

export const trackAddressSearchComponentError = (
  tracker: Tracker,
  numItemsInCart: number,
  savedAddress: boolean,
  source: TrackingSource
) => {
  tracker.track(TrackingEvents.ADDRESS_SEARCH_COMPONENT_ERROR, {
    num_items_in_cart: numItemsInCart,
    saved_address: savedAddress,
    source
  })
}

export const trackManualAddressButtonClicked = (
  tracker: Tracker,
  numItemsInCart: number,
  savedAddress: boolean,
  source: TrackingSource
) => {
  tracker.track(TrackingEvents.MANUAL_ADDRESS_BUTTON_CLICKED, {
    num_items_in_cart: numItemsInCart,
    saved_address: savedAddress,
    source
  })
}

export enum TrackingSource {
  Menu = 'menu',
  Checkout = 'checkout',
  MenuInvalidAdress = 'menu_invalid_address',
  CheckoutInvalidAdress = 'checkout_invalid_address',
  CheckoutBlockerModal = 'checkout_blocker_modal',
  DeliveryValidation = 'delivery_validation'
}

export const trackDiningOptionChangedV2 = (
  tracker: Tracker,
  selectedFulfillmentType: FulfillmentType,
  savedAddressUsed: boolean,
  source: TrackingSource,
  diningOptionBehavior: DiningOptionBehavior | undefined,
  deliveryInfo: DeliveryInfo | null | undefined
) => {
  tracker.track(TrackingEvents.DINING_OPTION_CHANGED_V2, {
    fulfillmentType: selectedFulfillmentType,
    savedAddressUsed:
      diningOptionBehavior === DiningOptionBehavior.Delivery
        ? savedAddressUsed
        : undefined,
    newDiningOptionBehavior: diningOptionBehavior,
    source,
    validDeliveryAddressPresent: !!deliveryInfo
  })
}

export const getInvalidTrackingSource = (source: TrackingSource) => {
  if (source === TrackingSource.Menu) {
    return TrackingSource.MenuInvalidAdress
  } else if (source === TrackingSource.Checkout) {
    return TrackingSource.CheckoutInvalidAdress
  }
  return source
}

export const getTrackingSourceFromPath = (
  path: string,
  checkoutPath: string,
  orderPath: string
) => {
  if (path === checkoutPath) {
    return TrackingSource.Checkout
  } else if (path === orderPath) {
    return TrackingSource.Menu
  }
  return TrackingSource.Menu
}
